import { createApp } from 'vue'
import store from './store'
import BasePage from './components/base/BasePage'
import LoginTeatro from './components/base/Login.vue'
import RegisterTeatro from './components/base/Register.vue'
import PasswordResetConfirm from './components/base/PasswordResetConfirm.vue'
import EmailConfirm from './components/base/EmailConfirm.vue'
import TeatroFooter from './components/base/TeatroFooter.vue'
import Popper from "vue3-popper";
import ApolloClient from './graphql'
import { createApolloProvider } from '@vue/apollo-option'
import vClickOutside from "click-outside-vue3"
import LandingTeatro from "@/components/camionmapapp/LandingTeatro.vue";
import ShowDetail from "@/components/camionmapapp/ShowDetail.vue";
import ReserveShow from "@/components/camionmapapp/ReserveShow.vue";
import ReservationList from "@/components/camionmapapp/ReservationList.vue";
import ReservationDetail from "@/components/camionmapapp/ReservationDetail.vue";
import PlayManager from "@/components/camionmapapp/PlayManager.vue";
import PlayForm from "@/components/camionmapapp/PlayForm.vue";
import CompanyProfile from "@/components/camionmapapp/CompanyProfile.vue";
import CompanyList from "@/components/camionmapapp/CompanyList.vue";
import ProductoraList from "@/components/camionmapapp/ProductoraList.vue";
import ProductoraForm from "@/components/camionmapapp/ProductoraForm.vue";
import ReservationsByPlay from "@/components/camionmapapp/ReservationsByPlay.vue";
import PlayReservations from "@/components/camionmapapp/PlayReservations.vue";
import SalesControl from "@/components/camionmapapp/SalesControl.vue";
import ClientList from "@/components/camionmapapp/ClientList.vue";
import ClientForm from "@/components/camionmapapp/ClientForm.vue";
import ReportSearch from "@/components/camionmapapp/ReportSearch.vue";
import SupportList from "@/components/camionmapapp/SupportList.vue";
import SupportForm from "@/components/camionmapapp/SupportForm.vue";
import PaymentsList from "@/components/camionmapapp/PaymentsList.vue";
import BusinessHistory from "@/components/camionmapapp/BusinessHistory.vue";
import DocumentViewer from "@/components/camionmapapp/DocumentViewer.vue";
import SectionPlaceholder from "@/components/camionmapapp/SectionPlaceholder.vue";
import CampaignList from "@/components/camionmapapp/CampaignList.vue";
import CampaignForm from "@/components/camionmapapp/CampaignForm.vue";
import CampaignDetail from "@/components/camionmapapp/CampaignDetail.vue";
import Faq from "@/components/camionmapapp/Faq.vue";
import About from './components/camionmapapp/About.vue'
import Terms from './components/camionmapapp/Terms.vue'
import "@/components/camionmapapp/teatro.css";

const apolloProvider = createApolloProvider({
  defaultClient: ApolloClient,
})
// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
const vuetify = createVuetify({
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: '#3D6662',
          secondary: '#FFCDD2'
        }
      },
    },
  },
  components,
  directives,
})

import './index.css'
import './styles/colors.css'

// Creamos una instancia de la aplicación Vue
const app = createApp({
  // Elemento html donde se va ha renderizar el contenido
  el: '#app',
  // Activamos el componente dentro de la app
  components : {
    BasePage,
    LoginTeatro,
    RegisterTeatro,
    LandingTeatro,
    ShowDetail,
    ReserveShow,
    ReservationList,
    ReservationDetail,
    PlayManager,
  },
  // Creamos variable msg reactiva con ref
  data () {
    return {
      msg: 'Componente de VueJsasdasdadS 3'
    }
  },
})
app.component("teatro-Popper", Popper);
app.component("TeatroFooter", TeatroFooter);
app.component("PasswordResetConfirm", PasswordResetConfirm);
app.component("EmailConfirm", EmailConfirm);
app.component("MyReservations", ReservationList);
app.component("AdminReservations", ReservationList);
app.component("ReservationList", ReservationList);
app.component("ReservationDetail", ReservationDetail);
app.component("PlayManager", PlayManager);
app.component("PlayForm", PlayForm);
app.component("CompanyProfile", CompanyProfile);
app.component("CompanyList", CompanyList);
app.component("ProductoraList", ProductoraList);
app.component("ProductoraForm", ProductoraForm);
app.component("ReservationsByPlay", ReservationsByPlay);
app.component("PlayReservations", PlayReservations);
app.component("SalesControl", SalesControl);
app.component("ClientList", ClientList);
app.component("ClientForm", ClientForm);
app.component("ReportSearch", ReportSearch);
app.component("SupportList", SupportList);
app.component("SupportForm", SupportForm);
app.component("PaymentsList", PaymentsList);
app.component("BusinessHistory", BusinessHistory);
app.component("DocumentViewer", DocumentViewer);
app.component("SectionPlaceholder", SectionPlaceholder);
app.component("CampaignList", CampaignList);
app.component("CampaignForm", CampaignForm);
app.component("CampaignDetail", CampaignDetail);
app.component("TeatroFaq", Faq);
app.component("TeatroAbout", About);
app.component("TeatroTerms", Terms);
app.use(store)
app.use(apolloProvider)
app.use(vClickOutside)
app.use(vuetify)
// Montamos la app en el div #app de nuestra plantilla index.html.
app.mount('#app')



